{
  "cycle.entite.attention_reports": "Reports d’éléments d’attention",
  "cycle.entite.conditions_acceptations": "Acceptations des conditions d’utilisation",
  "cycle.entite.confirmations_identite": "Confirmations d’identité",
  "cycle.entite.delegation_droits": "Droits transmis par délégation",
  "cycle.entite.entrees_brouillons": "Brouillons des entrées",
  "cycle.entite.evenements_prestataire": "Événements reçus du prestataire de paiement",
  "cycle.entite.exports_personnels": "Exports des données personnelles",
  "cycle.entite.favoris": "Espaces en favori",
  "cycle.entite.formules_score": "Formules de score des éléments",
  "cycle.entite.jetons_personnels": "Jetons personnels",
  "cycle.entite.operations_paiement": "Opérations de paiement",
  "cycle.entite.organisation_premiers_pas_masques": "Étapes des premiers pas masquées",
  "cycle.entite.preferences_affichage": "Préférences d’affichage",
  "cycle.entite.preuves_source_elements": "Preuves de source des éléments",
  "cycle.entite.programme_decisions_comite": "Décisions des comités de programme",
  "cycle.entite.profils_personnels": "Profils personnels",
  "cycle.entite.rapprochements": "Rapprochements des paiements",
  "cycle.entite.rattachements_proposes": "Propositions de rattachement à un programme",
  "cycle.entite.reactions": "Réactions aux éléments et commentaires",
  "cycle.entite.recents": "Espaces visités récemment",
  "cycle.entite.sante_publications": "Publications de la santé du projet",
  "cycle.entite.sessions_fermees": "Sessions fermées",
  "cycle.entite.statuts_personnels": "Statuts d’absence",
  "cycle.entite.suivis_objets": "Objets suivis",
  "cycle.entite.tests_quarantaine": "Quarantaines des cas de test",
  "journalAudit.action.account.deletion_cancelled": "Suppression du compte annulée",
  "journalAudit.action.account.deletion_requested": "Suppression du compte demandée",
  "journalAudit.action.account.display_preferences_updated": "Préférences d’affichage modifiées",
  "journalAudit.action.account.export_created": "Export des données personnelles préparé",
  "journalAudit.action.account.export_downloaded": "Export des données personnelles téléchargé",
  "journalAudit.action.account.profile_updated": "Profil personnel modifié",
  "journalAudit.action.account.status_updated": "Statut d’absence modifié",
  "journalAudit.action.account.terms_accepted": "Conditions d’utilisation acceptées",
  "journalAudit.action.backlog.implement_requested": "Lancement de la génération de code demandé",
  "journalAudit.action.invitation.declined": "Invitation au projet ignorée",
  "journalAudit.action.organisation.premiers_pas_affiches": "Premiers pas affichés de nouveau",
  "journalAudit.action.organisation.premiers_pas_masques": "Premiers pas masqués",
  "journalAudit.action.point.created": "Question ajoutée sur un document",
  "journalAudit.action.point.verified": "Intégration d’une réponse attestée",
  "journalAudit.action.project.attachment_accepted": "Rattachement au programme accepté",
  "journalAudit.action.project.attachment_refused": "Rattachement au programme refusé",
  "journalAudit.action.project.health_published": "Santé du projet publiée",
  "journalAudit.action.project.role_designated": "Rôle désigné dans le projet",
  "journalAudit.action.test_case.quarantaine_levee": "Quarantaine d’un cas de test levée",
  "journalAudit.action.test_case.quarantaine_posee": "Cas de test mis en quarantaine",
  "journalAudit.action.workspace.deletion_solicited": "Suppression du projet sollicitée"
}
